import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PackIllustration } from './PackIllustration';
import { images } from '../data/images';
import { offer } from '../data/offer';
const included = ['6 complete volumes, 300 pages', '54 ready-to-adapt sessions', '5 instant-use bonuses', 'Low, steady & high version of every session', 'Seated & wheelchair option for every move', '24 printable worksheets'];
export function Pricing() {
  const saving = offer.anchor - offer.price;
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-light text-ink" data-id="element-213" data-mp="25s7wnbafd22i">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-214" data-mp="20slf4pnkcznw">
        <div className="text-center" data-id="element-215" data-mp="20vhhcq6g2ai5">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court-deep" data-id="element-216" data-mp="3h6lg83y5avcq">
            Complete pack
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-217" data-mp="3c7ryu0fqmk7a">
            Everything you need for a full year of groups
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-line bg-white shadow-card" data-id="element-218" data-mp="9rpblovh35w7">
          <div className="bg-night px-5 py-5 text-center" data-id="element-219" data-mp="erv57alaz2gx">
            <h3 className="font-display text-xl font-bold tracking-tight text-white sm:text-2xl" data-id="element-220" data-mp="ep8wh7moegx4">
              Movement Group Ready: Complete Pack
            </h3>
            <p className="mt-1 text-[13px] font-bold text-shuttle" data-id="element-221" data-mp="3i8ttjwvs1d17">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-222" data-mp="3n5ahapz2dpdr">
            {images.pricing ? <img src={images.pricing} alt="Movement Group Ready complete pack: six volumes and five bonuses" width={1024} height={1024} loading="lazy" className="mx-auto w-full max-w-md rounded-2xl" data-id="element-223" data-mp="3rzenh70i9tds" /> : <PackIllustration className="mx-auto max-w-lg" data-id="element-224" data-mp="2reiaiftlojqn" />}

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-225" data-mp="2mhi423su9ez0">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-226" data-mp="318qzitjf9uk2">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-green" data-id="element-227" data-mp="2w8wc4zyuvn3r">
                    <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-228" data-mp="28k3b4p3dmp2a" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-line pt-6 text-center" data-id="element-229" data-mp="2ihhp8i1tv1rf">
              <p className="text-[13px] text-ink-soft" data-id="element-230" data-mp="2dg26wxr1b9cq">
                Total value{' '}
                <span className="text-ink-muted line-through" data-id="element-231" data-mp="3tuk3h6ggff8f">${offer.anchor} USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-232" data-mp="3ov7a02v2v9wv">
                <span className="mt-2.5 font-display text-3xl font-bold" data-id="element-233" data-mp="9uec5uymrka">$</span>
                <span className="font-display text-6xl font-bold leading-[0.9] sm:text-7xl" data-id="element-234" data-mp="59gschim4bu5">
                  {offer.price}
                </span>
                <span className="mt-3 text-[13px] font-bold text-ink-muted" data-id="element-235" data-mp="3ngel3ob8iu2c">USD</span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-236" data-mp="3rh6wan3o3919">
                <span className="rounded border border-shuttle bg-shuttle px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink" data-id="element-237" data-mp="j0ljswbttxte">
                  Save ${saving}
                </span>
                <span className="rounded border border-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-238" data-mp="a9cueb7r1t72">
                  One-time payment
                </span>
                <span className="rounded border border-line px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-ink-soft" data-id="element-239" data-mp="11zhb9zwavy3j">
                  Lifetime access
                </span>
              </div>

              <CtaButton href={offer.checkoutUrl} className="mt-5" data-id="element-240" data-mp="3f8ju27usab3n">
                Get Movement Group Ready, only ${offer.price}
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-241" data-mp="359cldxyzv4mv">
                Backed by the {offer.guaranteeDays}-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-242" data-mp="3192bia82zu2q">
                <li className="flex items-center gap-1.5" data-id="element-243" data-mp="1ruatiru7jir">
                  <LockIcon className="h-4 w-4 text-court" aria-hidden="true" data-id="element-244" data-mp="3synfiwlua0s1" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-245" data-mp="3o6drxn875csx">
                  <ZapIcon className="h-4 w-4 text-court" aria-hidden="true" data-id="element-246" data-mp="3k7ens4uahk2j" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-247" data-mp="kkepnwapbo3k">
                  <ShieldCheckIcon className="h-4 w-4 text-court" aria-hidden="true" data-id="element-248" data-mp="fs53mrcpj86k" />
                  {offer.guaranteeDays}-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-249" data-mp="23f178ifoini9">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}